import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  loaderHolder: {
    display: 'flex',
    justifyContent: 'center',
  },
});
